import { render, staticRenderFns } from "./ConcernEpisodeView.vue?vue&type=template&id=d863cd7c&scoped=true&"
import script from "./ConcernEpisodeView.vue?vue&type=script&lang=ts&"
export * from "./ConcernEpisodeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d863cd7c",
  null
  
)

export default component.exports